import { useState } from "preact/hooks";
import type { Question } from "../constants/questions";
import { tpl } from "../constants/strings";

interface Props {
  index: number;
  question: Question;
  companyName: string;
  value: number;
  onChange: (value: number) => void;
}

const STARS = [1, 2, 3, 4, 5] as const;

export function StarRatingQuestion({
  index,
  question,
  companyName,
  value,
  onChange,
}: Props) {
  const [hover, setHover] = useState(0);
  const displayValue = hover || value;
  const text = tpl(question.text, { company: companyName });

  return (
    <div class="tl-question">
      <div class="tl-question__head">
        <div class="tl-question__num">{index}</div>
        <div class="tl-question__text">{text}</div>
      </div>
      <div class="tl-question__body">
        <div class="tl-stars" onMouseLeave={() => setHover(0)}>
          {STARS.map((idx) => {
            const filled = idx <= displayValue;
            const isHover = hover === idx;
            const cls =
              "tl-stars__btn" +
              (filled ? " tl-stars__btn--active" : "") +
              (isHover ? " tl-stars__btn--hover" : "");
            return (
              <button
                type="button"
                key={idx}
                class={cls}
                aria-label={`${idx} von 5 Sternen`}
                aria-pressed={value === idx}
                onMouseEnter={() => setHover(idx)}
                onClick={() => onChange(idx)}
              >
                <span class="material-icons" aria-hidden="true">
                  {filled ? "star" : "star_border"}
                </span>
              </button>
            );
          })}
        </div>
        {question.scaleHint && (
          <div class="tl-scale-hint">
            <span>{question.scaleHint.low}</span>
            <span>{question.scaleHint.high}</span>
          </div>
        )}
      </div>
    </div>
  );
}
